import { render } from "./twoMemberList.vue?vue&type=template&id=4f59858d&scoped=true"
import script from "./twoMemberList.vue?vue&type=script&lang=js"
export * from "./twoMemberList.vue?vue&type=script&lang=js"

import "./twoMemberList.vue?vue&type=style&index=0&id=4f59858d&scoped=true&lang=less"

import exportComponent from "/Users/woniu/Desktop/woniu/web-tuiguangzu/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f59858d"]])

export default __exports__